import {
  faCogs,
  faBan,
  faAsterisk,
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBook,
  faCircleInfo,
  faChevronRight,
  faChevronDown,
  faClone,
  faCloud,
  faCommentDots,
  faDatabase,
  faEye,
  faFlag,
  faHeart,
  faHome,
  faList,
  faLock,
  faPencilAlt,
  faPlus,
  faSave,
  faSearch,
  faSort,
  faSync,
  faRoad,
  faSignInAlt,
  faSignOutAlt,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimesCircle,
  faTrash,
  faUpload,
  faUser,
  faUserPlus,
  faUsers,
  faUsersCog,
  faWrench,
} from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';

export const loadIcons = () => {
  library.add(
    faArrowLeft,
    faArrowRight,
    faCommentDots,
    faCircleInfo,
    faChevronRight,
    faChevronDown,
    faAsterisk,
    faBan,
    faBars,
    faBell,
    faBook,
    faClone,
    faCloud,
    faCogs,
    faDatabase,
    faEye,
    faFlag,
    faHeart,
    faHome,
    faList,
    faLock,
    faPencilAlt,
    faPlus,
    faRoad,
    faSave,
    faSignInAlt,
    faSignOutAlt,
    faSearch,
    faSort,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimesCircle,
    faTrash,
    faUser,
    faUpload,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWrench,
  );
};
